/**
 * Identifies which answer a voice recording belongs to.
 *
 * Transcription is async and Next is not gated on it, so a clip can resolve after the respondent
 * has moved on. Comparing the slot captured when recording started against the slot live at write
 * time is what stops a transcript landing on a question it was never spoken about. A question and
 * its AI follow-up are distinct slots — they persist as separate response_data entries.
 */

const SLOT_SEPARATOR = '|';
const MAIN_SLOT = 'main';
const FOLLOWUP_SLOT = 'followup';

export function makeAnswerSlotKey(
  questionId: string | number | null | undefined,
  questionIndex: number,
  isFollowup: boolean,
  /** How many follow-ups have been answered, and which MaxDiff set / conjoint scenario we are on.
   *  A question can host several follow-ups and several sets in a row, each a separate stored
   *  answer — without these, a transcript from follow-up 1 would pass the check during
   *  follow-up 2. */
  sequence: number = 0
): string {
  const question = questionId ?? questionIndex;
  const slot = isFollowup ? FOLLOWUP_SLOT : MAIN_SLOT;
  return `${question}${SLOT_SEPARATOR}${slot}${SLOT_SEPARATOR}${sequence}`;
}
